<label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
<textarea class="esf-form-item__field esf-text-area"
          [placeholder]="placeholder"
          [rows]="rows"
          [id]="id"
          [formControl]="formControl">
</textarea>
